import { FunctionComponent, useMemo } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

export type SlotProps = {
    from: Date;
    isSelected: boolean;
    isFocused: boolean;
    timezone?: string;
    locale?: string;
};

export const Slot: FunctionComponent<SlotProps> = ({
    from,
    isFocused,
    isSelected,
    timezone,
    locale,
}) => {
    const label = useMemo(() => {
        return new Intl.DateTimeFormat(locale, { timeStyle: 'short', timeZone: timezone }).format(
            from
        );
    }, [from, timezone, locale]);

    const className = classNames(styles.slot, {
        [styles.selected]: isSelected,
        [styles.focused]: isFocused,
    });

    return (
        <time className={className} dateTime={label}>
            {label}
        </time>
    );
};
